export const commonStyles = {
  cpaGold: "#E1A731",
  errorRed: "#d32f2f",
  fontSizes: {
    xlarge: 24,
    large: 20,
    medium: 16,
    small: 14,
  },
};
